module.exports = __webpack_public_path__ + "img/clock.df7c96e3.svg";